import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { siteData } from '../../data/mock';
import { useInView } from '../../hooks/useInView';

export const HeroSection = () => {
  const { hero } = siteData;
  const [ref, isInView] = useInView();

  return (
    <section className="relative pt-[140px] pb-[80px] lg:pt-[160px] lg:pb-[100px] bg-[#faf9f6] overflow-hidden">
      {/* Subtle ambient shapes */}
      <div className="absolute top-24 right-[8%] w-[450px] h-[450px] rounded-full bg-[#2d6a5a]/[0.025] blur-[100px] pointer-events-none" />
      <div className="absolute bottom-0 left-[5%] w-[350px] h-[350px] rounded-full bg-[#c4956a]/[0.03] blur-[80px] pointer-events-none" />

      <div
        ref={ref}
        className={`max-w-[1200px] mx-auto px-6 lg:px-8 relative z-10 ${
          isInView ? 'animate-fade-in-up' : 'opacity-0'
        }`}
      >
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          {/* Left: Text content */}
          <div>
            <h1 className="font-heading text-[2.75rem] sm:text-[3.5rem] lg:text-[3.75rem] leading-[1.06] font-bold text-stone-900 tracking-[-0.02em]">
              {hero.headline}
              <br />
              <span className="text-[#2d6a5a]">{hero.headlineAccent}</span>
            </h1>

            <p className="mt-7 text-[1.1rem] lg:text-[1.15rem] text-stone-500 leading-[1.7] max-w-[520px]">
              {hero.subheadline}
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <Button
                asChild
                className="bg-[#2d6a5a] hover:bg-[#245549] text-white rounded-full px-7 h-12 text-[0.92rem] font-medium hover:shadow-lg hover:shadow-[#2d6a5a]/15"
                style={{ transition: 'background-color 0.2s, box-shadow 0.3s' }}
              >
                <Link to={hero.primaryCta.href}>
                  {hero.primaryCta.label}
                  <ArrowRight className="ml-2" size={17} />
                </Link>
              </Button>

              <Button
                variant="ghost"
                asChild
                className="text-stone-500 hover:text-stone-800 hover:bg-stone-100/60 rounded-full px-5 h-12 text-[0.92rem] font-medium"
                style={{ transition: 'color 0.2s, background-color 0.2s' }}
              >
                <Link to={hero.secondaryCta.href}>{hero.secondaryCta.label}</Link>
              </Button>
            </div>
          </div>

          {/* Right: Product screenshot */}
          <div className="lg:flex lg:justify-end">
            <div
              className="relative rounded-[12px] border border-[#eee] shadow-[0_2px_12px_rgba(0,0,0,0.04)] overflow-hidden bg-white"
              style={{ maxWidth: '100%' }}
            >
              <img
                src="https://customer-assets.emergentagent.com/job_calm-operations-1/artifacts/6vhq65yk_Admin%20Panel%20Issue%20tracking.jpg"
                alt="bikes.rentals admin dashboard overview"
                className="block w-full h-auto"
                style={{ maxWidth: '100%' }}
              />
              <div
                className="absolute inset-0 pointer-events-none rounded-[12px]"
                style={{ background: 'rgba(255,255,255,0.05)' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
